import { html, TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import BaseInput from "./BaseInput";

@customElement("basic-input")
class BasicInput extends BaseInput {
	@property({ type: String }) type: "hidden" | "text" | "search" | "tel" | "url" | "email" | "password" | "datetime" | "date" | "month" | "week" | "time" | "datetime-local" | "number" | "range" | "color" | "checkbox" | "radio" | "file" | "submit" | "image" | "reset" | "button" | "hidden" = "text";
	protected renderInput(): TemplateResult {
		return html`
            <input 
                id="${this.id}"
                name="${this.name}"
                type="${this.type}" 
				value="${this.value}"
            />
        `;
	}
}

export default BasicInput;